<template>
    <div class="view-container">
        <modal
            :showDialog="
                activeModal === 'ADD' ||
                (activeModal == 'EDIT' && selectedServer != null)
            "
            @close="closeModal"
            :title="$t('AddServer')"
        >
            <add-cloud-modal :existing="selectedServer"></add-cloud-modal>
        </modal>
        <modal
            :showDialog="activeModal === 'ADD_SYSTEMS'"
            @close="closeModal"
            :title="$t('AddSystems')"
        >
            <add-cloud-system-modal
                :server="selectedServer"
                @save="closeModal(true)"
            ></add-cloud-system-modal>
        </modal>
        <modal
            :showDialog="activeModal === 'EDIT_ASSIGNMENT'"
            @close="closeModal"
            :title="$t('EditSystem')"
        >
            <edit-cloud-system
                :selectedSystem="selectedSystem"
                :server="selectedServer"
                @save="closeModal(true)"
            >
            </edit-cloud-system>
        </modal>
        <div>
            <div class="max-grid" style="flex-direction: row">
                <ejs-grid
                    ref="grid"
                    height="100%"
                    width="100%"
                    :toolbar="toolbar"
                    :toolbarClick="toolbarClick"
                    :selectionSettings="selectionOptions"
                    :allowTextWrap="true"
                    :textWrapSettings="wrapSettings"
                    :dataBound="dataBound"
                    :dataSource="servers"
                    :allowFiltering="true"
                    :filterSettings="filterOptions"
                    :allowSorting="true"
                    :showBusyIndicator="true"
                    style="position: relative"
                    :enablePersistence="false"
                    :rowSelected="selectionChanged"
                    :rowDeselected="selectionChanged"
                >
                    <e-columns>
                        <e-column
                            field="name"
                            :headerText="$t('Name')"
                            textAlign="Left"
                        ></e-column>
                        <e-column
                            field="address"
                            :headerText="$t('Address')"
                            textAlign="Left"
                        ></e-column>
                        <e-column
                            field="systemsCount"
                            :headerText="$t('Systems')"
                            textAlign="Left"
                        ></e-column>
                        <e-column
                            field="managerName"
                            :headerText="$t('Profile')"
                            textAlign="Left"
                        ></e-column>
                    </e-columns>
                </ejs-grid>
                <div
                    v-if="selectedServer != null"
                    class="messages-area"
                    style="min-width: 35%; width: 35%; margin: 0 0 0 10px"
                >
                    <h4
                        style="width: 100%; text-align: center; padding: 10px 0"
                    >
                        {{ $t("AssignedSystems") }}
                    </h4>
                    <ejs-grid
                        ref="gridSystems"
                        style="height: calc(100% - 20px); position: relative"
                        width="100%"
                        :toolbar="toolbarSystems"
                        :toolbarClick="toolbarClickSystems"
                        :selectionSettings="selectionOptionsSystems"
                        :allowTextWrap="true"
                        :textWrapSettings="wrapSettingsSystems"
                        :dataBound="dataBoundSystems"
                        :dataSource="systems"
                        :allowFiltering="true"
                        :filterSettings="filterOptionsSystems"
                        :allowSorting="true"
                        :showBusyIndicator="true"
                        :enablePersistence="false"
                    >
                        <e-columns>
                            <e-column
                                field="name"
                                :headerText="$t('Name')"
                                textAlign="Left"
                            ></e-column>
                            <e-column
                                field="herdIdentifier"
                                :headerText="$t('HerdIdentifier')"
                                textAlign="Left"
                            ></e-column>
                            <e-column
                                field="producerNumber"
                                :headerText="$t('ProducerNumber')"
                                textAlign="Left"
                            ></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Sort,
    Page,
    Filter,
    Toolbar,
    Search,
    CommandColumn,
    PdfExport,
    ExcelExport,
    ColumnChooser,
} from "@syncfusion/ej2-vue-grids";
import Modal from "../components/Modal.vue";
import AddCloudModal from "../components/Cloud/AddCloudModal.vue";
import AddCloudSystemModal from "../components/Cloud/AddCloudSystemModal.vue";
import EditCloudSystem from "../components/Cloud/EditCloudSystem.vue";

import { getCloudServers, getServerSystems, deleteServer } from "../api/api";

export default {
    components: {
        Modal,
        AddCloudModal,
        AddCloudSystemModal,
        EditCloudSystem,
    },
    data() {
        return {
            servers: [],
            systems: [],
            selectedServer: null,
            selectedSystem: null,
            activeModal: "",
            toolbar: [
                {
                    text: this.$t("ClearFilter"),
                    id: "clear-filters",
                    prefixIcon: "e-cancel",
                    align: "Right",
                },
                {
                    text: this.$t("AddConfiguration"),
                    tooltipText: "Add Configuration",
                    prefixIcon: "e-add",
                    id: "add-config",
                    align: "Right",
                },
                {
                    text: this.$t("EditConfiguration"),
                    tooltipText: "Edit Configuration",
                    prefixIcon: "e-edit",
                    id: "edit-config",
                    align: "Right",
                },
                {
                    text: this.$t("Delete"),
                    tooltipText: "Delete Configuration",
                    prefixIcon: "e-delete",
                    id: "delete-config",
                    align: "Right",
                },
                "Search",
            ],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Single" },
            filterOptions: {
                type: "Menu",
            },
            toolbarSystems: [
                {
                    text: this.$t("Add"),
                    tooltipText: "Add Systems",
                    prefixIcon: "e-add",
                    id: "add-systems",
                    align: "Right",
                },
                {
                    text: this.$t("Edit"),
                    tooltipText: "Edit System",
                    prefixIcon: "e-edit",
                    id: "edit-system",
                    align: "Right",
                },
                {
                    text: this.$t("Delete"),
                    tooltipText: "Delete",
                    prefixIcon: "e-delete",
                    id: "delete-systems",
                    align: "Right",
                },
                "Search",
            ],
            wrapSettingsSystems: { wrapMode: "Content" },
            selectionOptionsSystems: { type: "Single" },
            filterOptionsSystems: {
                type: "Menu",
            },
        };
    },
    provide: {
        grid: [
            Sort,
            Page,
            Filter,
            Toolbar,
            Search,
            CommandColumn,
            PdfExport,
            ExcelExport,
            ColumnChooser,
        ],
    },
    methods: {
        async getData() {
            this.servers = await getCloudServers();
        },
        toolbarClick: async function (args) {
            switch (args.item.id) {
                case "clear-filters":
                    this.$refs.grid.clearFiltering();
                    break;
                case "add-config":
                    this.openModal("ADD");
                    break;
                case "delete-config":
                    var selectedRow = this.$refs.grid.getSelectedRecords();
                    if (selectedRow.length > 1) {
                        alert("Select only one server to delete");
                    } else if (selectedRow.length == 0) {
                        alert("Select server to delete.");
                    }
                    await deleteServer(selectedRow[0].id);
                    this.getData();
            }
        },
        dataBound: function () {
            this.$refs.grid.autoFitColumns();
        },
        toolbarClickSystems: async function (args) {
            switch (args.item.id) {
                case "add-systems":
                    this.openModal("ADD_SYSTEMS");
                    break;
                case "delete-system":
                    this.openModal("DELETE_ASSIGMENT");
                    break;
                case "edit-system":
                    let selectedSystems =
                        this.$refs.gridSystems.getSelectedRecords();
                    if (selectedSystems.length == 1) {
                        this.selectedSystem = selectedSystems[0];
                    } else {
                        alert("Select only one system");
                        break;
                    }

                    console.log(this.selectedSystem);
                    console.log(this.selectedServer);

                    this.openModal("EDIT_ASSIGNMENT");
                    break;
            }
        },
        dataBoundSystems: function () {
            this.$refs.gridSystems.autoFitColumns();
        },
        closeModal(refresh) {
            if (refresh) {
                this.getData();
            }

            this.activeModal = "";
        },
        openModal(name) {
            this.activeModal = name;
        },
        selectionChanged() {
            var selection = this.$refs.grid.getSelectedRecords();

            if (selection.length != 1) {
                this.selectedServer = null;
                this.systems = [];
                return;
            }

            this.selectedServer = selection[0];

            getServerSystems(selection[0].id).then((result) => {
                this.systems = result.sort(this.sortSystemsByName);
            });
        },
        sortSystemsByName(a, b) {
            return a.name.localeCompare(b.name, undefined, {
                numeric: true,
                sensitivity: "base",
            });
        },
    },
    mounted: async function () {
        await this.getData();
    },
};
</script>

<style>
.messages-area {
    background: rgba(243, 243, 243, 1);
    border: 1px solid rgba(224, 224, 224, 1);
    border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/BackupCloud.vue